import {
  GET_PROVIDERS_BY_FRAMEWORK,
  GET_PROVIDERS_BY_FRAMEWORK_ERROR,
  GET_PROVIDERS_BY_FRAMEWORK_SUCCESS,
  GET_FRAMEWORK,
  GET_FRAMEWORK_ERROR,
  GET_FRAMEWORK_SUCCESS
} from './ProvidersByFrameworkSection.actions'

const providersByFrameworkSectionState = {
  data: [],
  frameworks: [],
  error: null,
  loading: false,
  page: 1,
  pages: 1,
  records: 1
}

/**
 * The providers by framework section's reducer.
 */
const providersByFrameworkSectionReducer = (state = providersByFrameworkSectionState, { payload, type }) => {
  switch (type) {
    case GET_PROVIDERS_BY_FRAMEWORK: {
      return { ...state, loading: true }
    }
    case GET_PROVIDERS_BY_FRAMEWORK_ERROR: {
      return { ...state, error: payload.error, loading: false, ...payload }
    }
    case GET_PROVIDERS_BY_FRAMEWORK_SUCCESS: {
      return { ...state, loading: false, ...payload }
    }
    case GET_FRAMEWORK: {
      return { ...state, loading: true }
    }
    case GET_FRAMEWORK_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_FRAMEWORK_SUCCESS: {
      return { ...state, loading: false, ...payload }
    }
    default: {
      return state
    }
  }
}

export default providersByFrameworkSectionReducer
